import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, Briefcase, Building, Laptop, Coffee, Globe2, Plus, Minus } from 'lucide-react';
import { Button } from '../components/Button';
export function Industries() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const industries = [{
    title: 'E-commerce & Trading',
    icon: ShoppingBag,
    desc: 'Setup for online marketplaces, dropshipping, and general trading licenses with customs registration support.'
  }, {
    title: 'Professional Services',
    icon: Briefcase,
    desc: 'Consultancies, agencies, and service providers requiring specialized activity codes and professional licenses.'
  }, {
    title: 'Real Estate & Property',
    icon: Building,
    desc: 'Property management, brokerage, and development support services for the real estate sector.'
  }, {
    title: 'Tech & Digital',
    icon: Laptop,
    desc: 'Software development, IT consultancy, and digital platforms benefiting from tech-focused Free Zone incentives.'
  }, {
    title: 'Hospitality & Lifestyle',
    icon: Coffee,
    desc: 'Event management, lifestyle consultancy, and hospitality support services.'
  }, {
    title: 'International Entrepreneurs',
    icon: Globe2,
    desc: 'Tailored packages for founders from LATAM, EU, and MENA regions establishing their regional HQ.'
  }];
  const faqs = [{
    q: 'How long does company setup take?',
    a: 'Typically 5-10 working days for the license issuance, depending on the specific activity and approvals required. Visa processing follows after the license is issued.'
  }, {
    q: 'What documents do I need to get started?',
    a: 'Generally, we need a passport copy, a passport-size photo, and your proposed company names. For certain activities, a business plan or CV might be requested.'
  }, {
    q: 'Do you handle visa applications?',
    a: 'Yes, we coordinate the entire visa process for investors and employees, including medical fitness tests and Emirates ID registration.'
  }, {
    q: 'What are your fees?',
    a: 'Our fees vary based on the package and license type. We provide a transparent, itemized quote upfront with no hidden charges.'
  }, {
    q: 'Can you help with bank account opening?',
    a: 'We provide introductions to our banking partners and assist with the documentation required for corporate bank account applications.'
  }, {
    q: 'Do you provide legal advice?',
    a: 'No, we are a corporate services provider. We do not provide regulated legal or financial advice. We can introduce you to qualified legal partners if needed.'
  }, {
    q: 'What Free Zones do you work with?',
    a: 'We primarily work with IFZA (International Free Zone Authority) and DSO (Dubai Silicon Oasis), but can assist with other jurisdictions based on your needs.'
  }, {
    q: 'How do I get started?',
    a: "Simply book a consultation or request a proposal through our website. We'll assess your needs and guide you through the next steps."
  }];
  return <div className="pt-10" data-id="element-369">
      {/* Header */}
      <section className="bg-gray-50 py-20" data-id="element-370">
        <div className="container-custom text-center" data-id="element-371">
          <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-372">
            Industries We Serve
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-373">
            Specialized expertise across key sectors driving Dubai's economy.
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20" data-id="element-374">
        <div className="container-custom" data-id="element-375">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-376">
            {industries.map((industry, index) => <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-377">
                <div className="bg-blue-50 w-14 h-14 rounded-lg flex items-center justify-center mb-6" data-id="element-378">
                  <industry.icon className="h-7 w-7 text-blue-800" data-id="element-379" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-380">
                  {industry.title}
                </h3>
                <p className="text-gray-600" data-id="element-381">{industry.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50" data-id="element-382">
        <div className="container-custom max-w-4xl" data-id="element-383">
          <div className="text-center mb-12" data-id="element-384">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-385">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600" data-id="element-386">
              Common questions about setting up and running a business in Dubai.
            </p>
          </div>

          <div className="space-y-4" data-id="element-387">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-388">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-389">
                  <span className="font-semibold text-gray-900" data-id="element-390">{faq.q}</span>
                  {openFaq === index ? <Minus className="h-5 w-5 text-blue-600" data-id="element-391" /> : <Plus className="h-5 w-5 text-gray-400" data-id="element-392" />}
                </button>
                <div className={`px-6 transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-40 py-4 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-393">
                  <p className="text-gray-600" data-id="element-394">{faq.a}</p>
                </div>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-395">
            <p className="text-gray-600 mb-4" data-id="element-396">Still have questions?</p>
            <Link to="/contact" data-id="element-397">
              <Button data-id="element-398">Contact Support</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>;
}